import { useMediaQuery } from "usehooks-ts";
import { useTheme } from "@/components/custom/theme/theme-provider";

export function useIsDarkMode() {
  const { theme } = useTheme();
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)", {
    initializeWithValue: true,
  });

  if (theme === "system") {
    return prefersDark;
  }
  return theme === "dark";
}
